import {
    GET_ELECTRICITY_PURCHASED_PER_FACILITY_FAIL,
    GET_ELECTRICITY_PURCHASED_PER_FACILITY_SUCCESS,
    GET_ELECTRICITY_PURCHASED_PER_GROUP_FAIL,
    GET_ELECTRICITY_PURCHASED_PER_GROUP_SUCCESS,
    // 
    GET_FUEL_COMBUSTED_PER_GROUP_DIESEL_STATIONARY_SUCCESS,
    GET_FUEL_COMBUSTED_PER_GROUP_DIESEL_STATIONARY_FAIL,
    GET_FUEL_COMBUSTED_PER_GROUP_PETROL_STATIONARY_SUCCESS,
    GET_FUEL_COMBUSTED_PER_GROUP_PETROL_STATIONARY_FAIL,
    GET_FUEL_COMBUSTED_PER_GROUP_DIESEL_MOBILE_SUCCESS,
    GET_FUEL_COMBUSTED_PER_GROUP_DIESEL_MOBILE_FAIL,
    GET_FUEL_COMBUSTED_PER_GROUP_PETROL_MOBILE_SUCCESS,
    GET_FUEL_COMBUSTED_PER_GROUP_PETROL_MOBILE_FAIL,
    // 
    GET_FUEL_COMBUSTED_PER_FACILITY_DIESEL_STATIONARY_SUCCESS,
    GET_FUEL_COMBUSTED_PER_FACILITY_DIESEL_STATIONARY_FAIL,
    GET_FUEL_COMBUSTED_PER_FACILITY_DIESEL_MOBILE_SUCCESS,
    GET_FUEL_COMBUSTED_PER_FACILITY_DIESEL_MOBILE_FAIL,
    GET_FUEL_COMBUSTED_PER_FACILITY_PETROL_MOBILE_SUCCESS,
    GET_FUEL_COMBUSTED_PER_FACILITY_PETROL_MOBILE_FAIL,
    GET_LPG_COMBUSTED_PER_GROUP_SUCCESS,
    GET_LPG_COMBUSTED_PER_GROUP_FAIL,
    GET_LPG_COMBUSTED_PER_FACILITY_SUCCESS,
    GET_LPG_COMBUSTED_PER_FACILITY_FAIL,
    // 
    GET_REFRIGERANT_GAS_TOP_UPS_PER_GROUP_SUCCESS,
    GET_REFRIGERANT_GAS_TOP_UPS_PER_GROUP_FAIL,
    GET_REFRIGERANT_GAS_TOP_UPS_PER_FACILITY_SUCCESS,
    GET_REFRIGERANT_GAS_TOP_UPS_PER_FACILITY_FAIL,
    //
    GET_DRY_ICE_PURCHASED_PER_GROUP_SUCCESS,
    GET_DRY_ICE_PURCHASED_PER_GROUP_FAIL,
    GET_DRY_ICE_PURCHASED_PER_FACILITY_SUCCESS,
    GET_DRY_ICE_PURCHASED_PER_FACILITY_FAIL,
    GET_WASTE_TO_LANDFILL_PER_GROUP_SUCCESS,
    GET_WASTE_TO_LANDFILL_PER_GROUP_FAIL,
    GET_WASTEWATER_TREATMENT_PER_GROUP_FAIL,
    GET_WASTE_TO_COMPOSTING_PER_GROUP_FAIL,
    GET_WASTE_TO_RECYCLING_PER_GROUP_FAIL,
    GET_WASTE_TO_RECYCLING_PER_GROUP_SUCCESS,
    GET_WASTE_TO_COMPOSTING_PER_GROUP_SUCCESS,
    GET_WASTEWATER_TREATMENT_PER_GROUP_SUCCESS,
    GET_WASTE_TO_BIOCHAR_PRODUCTION_PER_GROUP_SUCCESS,
    GET_WASTE_TO_BIOCHAR_PRODUCTION_PER_GROUP_FAIL,
    GET_WASTE_TO_LANDFILL_PER_FACILITY_SUCCESS,
    GET_WASTE_TO_LANDFILL_PER_FACILITY_FAIL,
    GET_WASTE_TO_RECYCLING_PER_FACILITY_SUCCESS,
    GET_WASTE_TO_RECYCLING_PER_FACILITY_FAIL,
    GET_WASTE_TO_COMPOSTING_PER_FACILITY_SUCCESS,
    GET_WASTE_TO_COMPOSTING_PER_FACILITY_FAIL,
    GET_WASTEWATER_TREATMENT_PER_FACILITY_SUCCESS,
    GET_WASTEWATER_TREATMENT_PER_FACILITY_FAIL,
    GET_WASTE_TO_BIOCHAR_PRODUCTION_PER_FACILITY_SUCCESS,
    GET_WASTE_TO_BIOCHAR_PRODUCTION_PER_FACILITY_FAIL,
    //
    GET_FLIGHTS_AND_ACCOMMODATION_PER_FACILITY_FAIL,
    GET_FLIGHTS_AND_ACCOMMODATION_PER_FACILITY_SUCCESS,
    GET_FLIGHTS_AND_ACCOMMODATION_PER_GROUP_FAIL,
    GET_FLIGHTS_AND_ACCOMMODATION_PER_GROUP_SUCCESS,
    //
    GET_CAR_HIRE_DIESEL_PER_GROUP_SUCCESS,
    GET_CAR_HIRE_DIESEL_PER_GROUP_FAIL,
    //
    GET_CAR_HIRE_PETROL_PER_GROUP_SUCCESS,
    GET_CAR_HIRE_PETROL_PER_GROUP_FAIL,
    //
    GET_CAR_HIRE_DIESEL_PER_FACILITY_SUCCESS,
    GET_CAR_HIRE_DIESEL_PER_FACILITY_FAIL,
    //
    GET_CAR_HIRE_PETROL_PER_FACILITY_SUCCESS,
    GET_CAR_HIRE_PETROL_PER_FACILITY_FAIL,
    //
    GET_PETROL_CARDS_DIESEL_PER_GROUP_SUCCESS,
    GET_PETROL_CARDS_DIESEL_PER_GROUP_FAIL,
    //
    GET_PETROL_CARDS_PETROL_PER_GROUP_SUCCESS,
    GET_PETROL_CARDS_PETROL_PER_GROUP_FAIL,
    //
    GET_PETROL_CARDS_DIESEL_PER_FACILITY_SUCCESS,
    GET_PETROL_CARDS_DIESEL_PER_FACILITY_FAIL,
    //
    GET_PETROL_CARDS_PETROL_PER_FACILITY_SUCCESS,
    GET_PETROL_CARDS_PETROL_PER_FACILITY_FAIL,
    //
    GET_INTER_DC_DISTRIBUTION_PER_GROUP_SUCCESS,
    GET_INTER_DC_DISTRIBUTION_PER_GROUP_FAIL,
    GET_FARM_DC_DISTRIBUTION_PER_GROUP_SUCCESS,
    GET_FARM_DC_DISTRIBUTION_PER_GROUP_FAIL,
    GET_SHIPPING_DISTRIBUTION_PER_GROUP_SUCCESS,
    GET_SHIPPING_DISTRIBUTION_PER_GROUP_FAIL,
    GET_REGIONAL_DISTRIBUTION_PER_GROUP_SUCCESS,
    GET_REGIONAL_DISTRIBUTION_PER_GROUP_FAIL,
    //
    GET_INTER_DC_DISTRIBUTION_PER_FACILITY_SUCCESS,
    GET_INTER_DC_DISTRIBUTION_PER_FACILITY_FAIL,
    GET_FARM_DC_DISTRIBUTION_PER_FACILITY_SUCCESS,
    GET_FARM_DC_DISTRIBUTION_PER_FACILITY_FAIL,
    GET_SHIPPING_DISTRIBUTION_PER_FACILITY_SUCCESS,
    GET_SHIPPING_DISTRIBUTION_PER_FACILITY_FAIL,
    GET_REGIONAL_DISTRIBUTION_PER_FACILITY_SUCCESS,
    GET_REGIONAL_DISTRIBUTION_PER_FACILITY_FAIL,
    //
    GET_WATER_PER_GROUP_SUCCESS,
    GET_WATER_PER_FACILITY_SUCCESS,
    GET_WATER_PER_FACILITY_FAIL,
    GET_WATER_PER_GROUP_FAIL,
    GET_CHEMICALS_AND_ADDITIVES_PER_GROUP_SUCCESS,
    GET_CHEMICALS_AND_ADDITIVES_PER_FACILITY_FAIL,
    GET_CHEMICALS_AND_ADDITIVES_PER_FACILITY_SUCCESS,
    GET_CHEMICALS_AND_ADDITIVES_PER_GROUP_FAIL,
    GET_WOODEN_PRODUCTS_PER_GROUP_SUCCESS,
    GET_WOODEN_PRODUCTS_PER_GROUP_FAIL,
    GET_WOODEN_PRODUCTS_PER_FACILITY_SUCCESS,
    GET_WOODEN_PRODUCTS_PER_FACILITY_FAIL,
    GET_PACKAGING_PER_FACILITY_FAIL,
    GET_PACKAGING_PER_FACILITY_SUCCESS,
    GET_PACKAGING_PER_GROUP_FAIL,
    GET_PACKAGING_PER_GROUP_SUCCESS,
    GET_WINE_AND_GRAPES_PER_FACILITY_FAIL,
    GET_WINE_AND_GRAPES_PER_FACILITY_SUCCESS,
    GET_WINE_AND_GRAPES_PER_GROUP_FAIL,
    GET_WINE_AND_GRAPES_PER_GROUP_SUCCESS,
    GET_OTHER_PER_FACILITY_FAIL,
    GET_OTHER_PER_FACILITY_SUCCESS,
    GET_OTHER_PER_GROUP_FAIL,
    GET_OTHER_PER_GROUP_SUCCESS,
    START_LOADING,
    GET_FERTILIZERS_PER_GROUP_SUCCESS,
    GET_FERTILIZERS_PER_GROUP_FAIL,
    GET_AGROCHEMICALS_PER_GROUP_SUCCESS,
    GET_AGROCHEMICALS_PER_GROUP_FAIL,
    GET_FERTILIZERS_PER_FACILITY_SUCCESS,
    GET_FERTILIZERS_PER_FACILITY_FAIL,
    GET_AGROCHEMICALS_PER_FACILITY_SUCCESS,
    GET_AGROCHEMICALS_PER_FACILITY_FAIL,
    GET_CAPITAL_GOODS_AND_SERVICES_PER_GROUP_SUCCESS,
    GET_CAPITAL_GOODS_AND_SERVICES_PER_GROUP_FAIL,
    GET_CAPITAL_GOODS_AND_SERVICES_PER_FACILITY_SUCCESS,
    GET_CAPITAL_GOODS_AND_SERVICES_PER_FACILITY_FAIL,
    EXPORT_COMPANY_CONSUMPTION_SUCCESS,
    EXPORT_COMPANY_CONSUMPTION_FAIL,
    EXPORT_GROUP_CONSUMPTION_SUCCESS,
    EXPORT_GROUP_CONSUMPTION_FAIL,
    GET_RENEWABLE_ENERGY_PER_GROUP_SUCCESS,
    GET_RENEWABLE_ENERGY_PER_GROUP_FAIL,
    GET_RENEWABLE_ENERGY_PER_FACILITY_SUCCESS,
    GET_RENEWABLE_ENERGY_PER_FACILITY_FAIL
} from '../../../actions/carbonfootprint-rework/types/06-dashboard';


const initialState = {
    loading: true,
    electricityPurchasedPerFacility: [],
    electricityPurchasedPerGroup: [],
    renewableEnergyPerGroup: [],
    renewableEnergyPerFacility: [],
    // fuel
    fuelCombustedDieselStationaryPerGroup: [],
    fuelCombustedDieselMobilePerGroup: [],
    fuelCombustedPetrolStationaryPerGroup: [],
    fuelCombustedPetrolMobilePerGroup: [],
    fuelCombustedDieselStationaryPerFacility: [],
    fuelCombustedDieselMobilePerFacility: [],
    fuelCombustedPetrolMobilePerFacility: [],
    // lpg
    lpgCombustedPerFacility: [],
    lpgCombustedPerGroup: [],
    // refrigerant gas top ups
    refrigerantGasTopUpsPerGroup: [],
    refrigerantGasTopUpsPerFacility: [],
    // dry ice purchased
    dryIcePurchasedPerGroup: [],
    dryIcePurchasedPerFacility: [],
    // waste generated per group
    wasteToLandfillPerGroup: [],
    wasteToRecyclingPerGroup: [],
    wasteToCompostingPerGroup: [],
    wastewaterTreatmentPerGroup: [],
    wasteToBiocharProductionPerGroup: [],
    // waste generated per facility
    wasteToLandfillPerFacility: [],
    wasteToRecyclingPerFacility: [],
    wasteToCompostingPerFacility: [],
    wastewaterTreatmentPerFacility: [],
    wasteToBiocharProductionPerFacility: [],
    // Flights and Accommodation
    flightsAndAccommodationPerGroup: [],
    flightsAndAccommodationPerFacility: [],
    // Car hire
    // diesel
    carHireDieselPerGroup: [],
    carHireDieselPerFacility: [],
    // petrol
    carHirePetrolPerGroup: [],
    carHirePetrolPerFacility: [],
    // Petrol cards
    // diesel
    petrolCardsDieselPerGroup: [],
    petrolCardsDieselPerFacility: [],
    // petrol
    petrolCardsPetrolPerGroup: [],
    petrolCardsPetrolPerFacility: [],
    // downstream distribution per group
    interDcDistributionPerGroup: [],
    farmDcDistributionPerGroup: [],
    shippingDistributionPerGroup: [],
    regionalDistributionPerGroup: [],
    // downstream distribution per facility
    interDcDistributionPerFacility: [],
    farmDcDistributionPerFacility: [],
    shippingDistributionPerFacility: [],
    regionalDistributionPerFacility: [],
    // water per group
    waterPerGroup: [],
    // water per facility
    waterPerFacility: [],
    // chemicals and additives per group
    chemicalsAndAdditivesPerGroup: [],
    // chemicals and additives per facility
    chemicalsAndAdditivesPerFacility: [],
    // wooden products per group
    woodenProductsPerGroup: [],
    // wooden products per facility
    woodenProductsPerFacility: [],
    // packaging per group
    packagingPerGroup: [],
    // packaging per facility
    packagingPerFacility: [],
    // wine and grapes per group
    wineAndGrapesPerGroup: [],
    // wine and grapes per facility
    wineAndGrapesPerFacility: [],
    // other per group
    otherPerGroup: [],
    // other per facility
    otherPerFacility: [],
    // fertilizers per group
    fertilizersPerGroup: [],
    // fertilizers per facility
    fertilizersPerFacility: [],
    // agrochemicals per group
    agrochemicalsPerGroup: [],
    // agrochemicals per facility
    agrochemicalsPerFacility: [],
    // capital goods and services per group
    capitalGoodsAndServicesPerGroup: [],
    // capital goods and services per facility
    capitalGoodsAndServicesPerFacility: [],
    // consumption export
    companyConsumptionExport: [],
    groupConsumptionExport: []
};


export default function
    carbonFootprintDashboardReducer(state = initialState, action) {

    const { type, payload } = action;

    switch (type) {
        case START_LOADING:
            return {
                ...state,
                loading: true
            }
        // ELECTRICITY PURCHASED
        case GET_ELECTRICITY_PURCHASED_PER_GROUP_SUCCESS:
            return {
                ...state,
                loading: false,
                electricityPurchasedPerGroup: payload
            };
        case GET_ELECTRICITY_PURCHASED_PER_GROUP_FAIL:
            return {
                ...state,
                loading: false,
                electricityPurchasedPerGroup: payload
            };
        case GET_ELECTRICITY_PURCHASED_PER_FACILITY_SUCCESS:
            return {
                ...state,
                loading: false,
                electricityPurchasedPerFacility: payload
            };
        case GET_ELECTRICITY_PURCHASED_PER_FACILITY_FAIL:
            return {
                ...state,
                loading: false,
                electricityPurchasedPerFacility: payload
            };
        // RENEWABLE ENERGY
        case GET_RENEWABLE_ENERGY_PER_GROUP_SUCCESS:
            return {
                ...state,
                loading: false,
                renewableEnergyPerGroup: payload
            };
        case GET_RENEWABLE_ENERGY_PER_GROUP_FAIL:
            return {
                ...state,
                loading: false,
                renewableEnergyPerGroup: payload
            };
        case GET_RENEWABLE_ENERGY_PER_FACILITY_SUCCESS:
            return {
                ...state,
                loading: false,
                renewableEnergyPerFacility: payload
            };
        case GET_RENEWABLE_ENERGY_PER_FACILITY_FAIL:
            return {
                ...state,
                loading: false,
                renewableEnergyPerFacility: payload
            };
        // group stationary
        case GET_FUEL_COMBUSTED_PER_GROUP_DIESEL_STATIONARY_SUCCESS:
            return {
                ...state,
                loading: false,
                fuelCombustedDieselStationaryPerGroup: payload
            };
        case GET_FUEL_COMBUSTED_PER_GROUP_DIESEL_STATIONARY_FAIL:
            return {
                ...state,
                loading: false,
                fuelCombustedDieselStationaryPerGroup: payload
            }
        case GET_FUEL_COMBUSTED_PER_GROUP_PETROL_STATIONARY_SUCCESS:
            return {
                ...state,
                loading: false,
                fuelCombustedPetrolStationaryPerGroup: payload
            };
        case GET_FUEL_COMBUSTED_PER_GROUP_PETROL_STATIONARY_FAIL:
            return {
                ...state,
                loading: false,
                fuelCombustedPetrolStationaryPerGroup: payload
            }
        // group mobile
        case GET_FUEL_COMBUSTED_PER_GROUP_DIESEL_MOBILE_SUCCESS:
            return {
                ...state,
                loading: false,
                fuelCombustedDieselMobilePerGroup: payload
            };
        case GET_FUEL_COMBUSTED_PER_GROUP_DIESEL_MOBILE_FAIL:
            return {
                ...state,
                loading: false,
                fuelCombustedDieselMobilePerGroup: payload
            }
        case GET_FUEL_COMBUSTED_PER_GROUP_PETROL_MOBILE_SUCCESS:
            return {
                ...state,
                loading: false,
                fuelCombustedPetrolMobilePerGroup: payload
            };
        case GET_FUEL_COMBUSTED_PER_GROUP_PETROL_MOBILE_FAIL:
            return {
                ...state,
                loading: false,
                fuelCombustedPetrolMobilePerGroup: payload
            }
        // FUEL COMBUSTED PER FACILITY
        case GET_FUEL_COMBUSTED_PER_FACILITY_DIESEL_STATIONARY_SUCCESS:
            return {
                ...state,
                loading: false,
                fuelCombustedDieselStationaryPerFacility: payload
            };
        case GET_FUEL_COMBUSTED_PER_FACILITY_DIESEL_STATIONARY_FAIL:
            return {
                ...state,
                loading: false,
                fuelCombustedDieselStationaryPerFacility: payload
            };
        case GET_FUEL_COMBUSTED_PER_FACILITY_DIESEL_MOBILE_SUCCESS:
            return {
                ...state,
                loading: false,
                fuelCombustedDieselMobilePerFacility: payload
            };
        case GET_FUEL_COMBUSTED_PER_FACILITY_DIESEL_MOBILE_FAIL:
            return {
                ...state,
                loading: false,
                fuelCombustedDieselMobilePerFacility: payload
            };
        case GET_FUEL_COMBUSTED_PER_FACILITY_PETROL_MOBILE_SUCCESS:
            return {
                ...state,
                loading: false,
                fuelCombustedPetrolMobilePerFacility: payload
            };
        case GET_FUEL_COMBUSTED_PER_FACILITY_PETROL_MOBILE_FAIL:
            return {
                ...state,
                loading: false,
                fuelCombustedPetrolMobilePerFacility: payload
            };
        // LPG COMBUSTED
        case GET_LPG_COMBUSTED_PER_GROUP_SUCCESS:
            return {
                ...state,
                loading: false,
                lpgCombustedPerGroup: payload
            };
        case GET_LPG_COMBUSTED_PER_GROUP_FAIL:
            return {
                ...state,
                loading: false,
                lpgCombustedPerGroup: payload
            };
        case GET_LPG_COMBUSTED_PER_FACILITY_SUCCESS:
            return {
                ...state,
                loading: false,
                lpgCombustedPerFacility: payload
            };
        case GET_LPG_COMBUSTED_PER_FACILITY_FAIL:
            return {
                ...state,
                loading: false,
                lpgCombustedPerFacility: payload
            };
        // ELECTRICITY PURCHASED
        case GET_REFRIGERANT_GAS_TOP_UPS_PER_GROUP_SUCCESS:
            return {
                ...state,
                loading: false,
                refrigerantGasTopUpsPerGroup: payload
            };
        case GET_REFRIGERANT_GAS_TOP_UPS_PER_GROUP_FAIL:
            return {
                ...state,
                loading: false,
                refrigerantGasTopUpsPerGroup: payload
            };
        case GET_REFRIGERANT_GAS_TOP_UPS_PER_FACILITY_SUCCESS:
            return {
                ...state,
                loading: false,
                refrigerantGasTopUpsPerFacility: payload
            };
        case GET_REFRIGERANT_GAS_TOP_UPS_PER_FACILITY_FAIL:
            return {
                ...state,
                loading: false,
                refrigerantGasTopUpsPerFacility: payload
            };
        // DRY ICE PURCHASED
        case GET_DRY_ICE_PURCHASED_PER_GROUP_SUCCESS:
            return {
                ...state,
                loading: false,
                dryIcePurchasedPerGroup: payload
            };
        case GET_DRY_ICE_PURCHASED_PER_GROUP_FAIL:
            return {
                ...state,
                loading: false,
                dryIcePurchasedPerGroup: payload
            };
        case GET_DRY_ICE_PURCHASED_PER_FACILITY_SUCCESS:
            return {
                ...state,
                loading: false,
                dryIcePurchasedPerFacility: payload
            };
        case GET_DRY_ICE_PURCHASED_PER_FACILITY_FAIL:
            return {
                ...state,
                loading: false,
                dryIcePurchasedPerFacility: payload
            };
        // WASTE GENERATED PER GROUP
        case GET_WASTE_TO_LANDFILL_PER_GROUP_SUCCESS:
            return {
                ...state,
                loading: false,
                wasteToLandfillPerGroup: payload
            }
        case GET_WASTE_TO_LANDFILL_PER_GROUP_FAIL:
            return {
                ...state,
                loading: false,
                wasteToLandfillPerGroup: payload
            }
        case GET_WASTE_TO_RECYCLING_PER_GROUP_SUCCESS:
            return {
                ...state,
                loading: false,
                wasteToRecyclingPerGroup: payload
            }
        case GET_WASTE_TO_RECYCLING_PER_GROUP_FAIL:
            return {
                ...state,
                loading: false,
                wasteToRecyclingPerGroup: payload
            }
        case GET_WASTE_TO_COMPOSTING_PER_GROUP_SUCCESS:
            return {
                ...state,
                loading: false,
                wasteToCompostingPerGroup: payload
            }
        case GET_WASTE_TO_COMPOSTING_PER_GROUP_FAIL:
            return {
                ...state,
                loading: false,
                wasteToCompostingPerGroup: payload
            }
        case GET_WASTEWATER_TREATMENT_PER_GROUP_SUCCESS:
            return {
                ...state,
                loading: false,
                wastewaterTreatmentPerGroup: payload
            }
        case GET_WASTEWATER_TREATMENT_PER_GROUP_FAIL:
            return {
                ...state,
                loading: false,
                wastewaterTreatmentPerGroup: payload
            }
        case GET_WASTE_TO_BIOCHAR_PRODUCTION_PER_GROUP_SUCCESS:
            return {
                ...state,
                loading: false,
                wasteToBiocharProductionPerGroup: payload
            }
        case GET_WASTE_TO_BIOCHAR_PRODUCTION_PER_GROUP_FAIL:
            return {
                ...state,
                loading: false,
                wasteToBiocharProductionPerGroup: payload
            }
        // WASTE GENERATED PER FACILITY
        case GET_WASTE_TO_LANDFILL_PER_FACILITY_SUCCESS:
            return {
                ...state,
                loading: false,
                wasteToLandfillPerFacility: payload
            }
        case GET_WASTE_TO_LANDFILL_PER_FACILITY_FAIL:
            return {
                ...state,
                loading: false,
                wasteToLandfillPerFacility: payload
            }
        case GET_WASTE_TO_RECYCLING_PER_FACILITY_SUCCESS:
            return {
                ...state,
                loading: false,
                wasteToRecyclingPerFacility: payload
            }
        case GET_WASTE_TO_RECYCLING_PER_FACILITY_FAIL:
            return {
                ...state,
                loading: false,
                wasteToRecyclingPerFacility: payload
            }
        case GET_WASTE_TO_COMPOSTING_PER_FACILITY_SUCCESS:
            return {
                ...state,
                loading: false,
                wasteToCompostingPerFacility: payload
            }
        case GET_WASTE_TO_COMPOSTING_PER_FACILITY_FAIL:
            return {
                ...state,
                loading: false,
                wasteToCompostingPerFacility: payload
            }
        case GET_WASTEWATER_TREATMENT_PER_FACILITY_SUCCESS:
            return {
                ...state,
                loading: false,
                wastewaterTreatmentPerFacility: payload
            }
        case GET_WASTEWATER_TREATMENT_PER_FACILITY_FAIL:
            return {
                ...state,
                loading: false,
                wastewaterTreatmentPerFacility: payload
            }
        case GET_WASTE_TO_BIOCHAR_PRODUCTION_PER_FACILITY_SUCCESS:
            return {
                ...state,
                loading: false,
                wasteToBiocharProductionPerFacility: payload
            }
        case GET_WASTE_TO_BIOCHAR_PRODUCTION_PER_FACILITY_FAIL:
            return {
                ...state,
                loading: false,
                wasteToBiocharProductionPerFacility: payload
            }
        // FLIGHTS AND ACCOMMODATION PER GROUP
        case GET_FLIGHTS_AND_ACCOMMODATION_PER_GROUP_SUCCESS:
            return {
                ...state,
                loading: false,
                flightsAndAccommodationPerGroup: payload
            };
        case GET_FLIGHTS_AND_ACCOMMODATION_PER_GROUP_FAIL:
            return {
                ...state,
                loading: false,
                flightsAndAccommodationPerGroup: payload
            };
        // FLIGHTS AND ACCOMMODATION PER FACILITY
        case GET_FLIGHTS_AND_ACCOMMODATION_PER_FACILITY_SUCCESS:
            return {
                ...state,
                loading: false,
                flightsAndAccommodationPerFacility: payload
            };
        case GET_FLIGHTS_AND_ACCOMMODATION_PER_FACILITY_FAIL:
            return {
                ...state,
                loading: false,
                flightsAndAccommodationPerFacility: payload
            };
        // CAR HIRE PER GROUP
        //diesel
        case GET_CAR_HIRE_DIESEL_PER_GROUP_SUCCESS:
            return {
                ...state,
                loading: false,
                carHireDieselPerGroup: payload
            };
        case GET_CAR_HIRE_DIESEL_PER_GROUP_FAIL:
            return {
                ...state,
                loading: false,
                carHireDieselPerGroup: payload
            };
        //petrol
        case GET_CAR_HIRE_PETROL_PER_GROUP_SUCCESS:
            return {
                ...state,
                loading: false,
                carHirePetrolPerGroup: payload
            };
        case GET_CAR_HIRE_PETROL_PER_GROUP_FAIL:
            return {
                ...state,
                loading: false,
                carHirePetrolPerGroup: payload
            };
        // CAR HIRE PER FACILITY
        // diesel
        case GET_CAR_HIRE_DIESEL_PER_FACILITY_SUCCESS:
            return {
                ...state,
                loading: false,
                carHireDieselPerFacility: payload
            };
        case GET_CAR_HIRE_DIESEL_PER_FACILITY_FAIL:
            return {
                ...state,
                loading: false,
                carHireDieselPerFacility: payload
            };
        // petrol
        case GET_CAR_HIRE_PETROL_PER_FACILITY_SUCCESS:
            return {
                ...state,
                loading: false,
                carHirePetrolPerFacility: payload
            };
        case GET_CAR_HIRE_PETROL_PER_FACILITY_FAIL:
            return {
                ...state,
                loading: false,
                carHirePetrolPerFacility: payload
            };
        // PETROL CARDS PER GROUP
        // diesel
        case GET_PETROL_CARDS_DIESEL_PER_GROUP_SUCCESS:
            return {
                ...state,
                loading: false,
                petrolCardsDieselPerGroup: payload
            };
        case GET_PETROL_CARDS_DIESEL_PER_GROUP_FAIL:
            return {
                ...state,
                loading: false,
                petrolCardsDieselPerGroup: payload
            };
        // petrol
        case GET_PETROL_CARDS_PETROL_PER_GROUP_SUCCESS:
            return {
                ...state,
                loading: false,
                petrolCardsPetrolPerGroup: payload
            };
        case GET_PETROL_CARDS_PETROL_PER_GROUP_FAIL:
            return {
                ...state,
                loading: false,
                petrolCardsPetrolPerGroup: payload
            };
        // PETROL CARDS PER FACILITY
        // diesel
        case GET_PETROL_CARDS_DIESEL_PER_FACILITY_SUCCESS:
            return {
                ...state,
                loading: false,
                petrolCardsDieselPerFacility: payload
            };
        case GET_PETROL_CARDS_DIESEL_PER_FACILITY_FAIL:
            return {
                ...state,
                loading: false,
                petrolCardsDieselPerFacility: payload
            };
        // petrol
        case GET_PETROL_CARDS_PETROL_PER_FACILITY_SUCCESS:
            return {
                ...state,
                loading: false,
                petrolCardsPetrolPerFacility: payload
            };
        case GET_PETROL_CARDS_PETROL_PER_FACILITY_FAIL:
            return {
                ...state,
                loading: false,
                petrolCardsPetrolPerFacility: payload
            };
        // DOWNSTREAM DISTRIBUTION PER GROUP
        case GET_INTER_DC_DISTRIBUTION_PER_GROUP_SUCCESS:
            return {
                ...state,
                loading: false,
                interDcDistributionPerGroup: payload
            };
        case GET_INTER_DC_DISTRIBUTION_PER_GROUP_FAIL:
            return {
                ...state,
                loading: false,
                interDcDistributionPerGroup: payload
            };
        case GET_FARM_DC_DISTRIBUTION_PER_GROUP_SUCCESS:
            return {
                ...state,
                loading: false,
                farmDcDistributionPerGroup: payload
            };
        case GET_FARM_DC_DISTRIBUTION_PER_GROUP_FAIL:
            return {
                ...state,
                loading: false,
                farmDcDistributionPerGroup: payload
            };
        case GET_SHIPPING_DISTRIBUTION_PER_GROUP_SUCCESS:
            return {
                ...state,
                loading: false,
                shippingDistributionPerGroup: payload
            };
        case GET_SHIPPING_DISTRIBUTION_PER_GROUP_FAIL:
            return {
                ...state,
                loading: false,
                shippingDistributionPerGroup: payload
            };
        case GET_REGIONAL_DISTRIBUTION_PER_GROUP_SUCCESS:
            return {
                ...state,
                loading: false,
                regionalDistributionPerGroup: payload
            };
        case GET_REGIONAL_DISTRIBUTION_PER_GROUP_FAIL:
            return {
                ...state,
                loading: false,
                regionalDistributionPerGroup: payload
            };
        // DOWNSTREAM DISTRIBUTION PER FACILITY
        case GET_INTER_DC_DISTRIBUTION_PER_FACILITY_SUCCESS:
            return {
                ...state,
                loading: false,
                interDcDistributionPerFacility: payload
            };
        case GET_INTER_DC_DISTRIBUTION_PER_FACILITY_FAIL:
            return {
                ...state,
                loading: false,
                interDcDistributionPerFacility: payload
            };
        case GET_FARM_DC_DISTRIBUTION_PER_FACILITY_SUCCESS:
            return {
                ...state,
                loading: false,
                farmDcDistributionPerFacility: payload
            };
        case GET_FARM_DC_DISTRIBUTION_PER_FACILITY_FAIL:
            return {
                ...state,
                loading: false,
                farmDcDistributionPerFacility: payload
            };
        case GET_SHIPPING_DISTRIBUTION_PER_FACILITY_SUCCESS:
            return {
                ...state,
                loading: false,
                shippingDistributionPerFacility: payload
            };
        case GET_SHIPPING_DISTRIBUTION_PER_FACILITY_FAIL:
            return {
                ...state,
                loading: false,
                shippingDistributionPerFacility: payload
            };
        case GET_REGIONAL_DISTRIBUTION_PER_FACILITY_SUCCESS:
            return {
                ...state,
                loading: false,
                regionalDistributionPerFacility: payload
            };
        case GET_REGIONAL_DISTRIBUTION_PER_FACILITY_FAIL:
            return {
                ...state,
                loading: false,
                regionalDistributionPerFacility: payload
            };
        case GET_WATER_PER_GROUP_SUCCESS:
            return {
                ...state,
                loading: false,
                waterPerGroup: payload
            }
        case GET_WATER_PER_GROUP_FAIL:
            return {
                ...state,
                loading: false,
                waterPerGroup: payload
            }
        case GET_WATER_PER_FACILITY_SUCCESS:
            return {
                ...state,
                loading: false,
                waterPerFacility: payload
            }
        case GET_WATER_PER_FACILITY_FAIL:
            return {
                ...state,
                loading: false,
                waterPerFacility: payload
            }
        case GET_CHEMICALS_AND_ADDITIVES_PER_GROUP_SUCCESS:
            return {
                ...state,
                loading: false,
                chemicalsAndAdditivesPerGroup: payload
            }
        case GET_CHEMICALS_AND_ADDITIVES_PER_GROUP_FAIL:
            return {
                ...state,
                loading: false,
                chemicalsAndAdditivesPerGroup: payload
            }
        case GET_CHEMICALS_AND_ADDITIVES_PER_FACILITY_SUCCESS:
            return {
                ...state,
                loading: false,
                chemicalsAndAdditivesPerFacility: payload
            }
        case GET_CHEMICALS_AND_ADDITIVES_PER_FACILITY_FAIL:
            return {
                ...state,
                loading: false,
                chemicalsAndAdditivesPerFacility: payload
            }
        //
        case GET_WOODEN_PRODUCTS_PER_GROUP_SUCCESS:
            return {
                ...state,
                loading: false,
                woodenProductsPerGroup: payload
            }
        case GET_WOODEN_PRODUCTS_PER_GROUP_FAIL:
            return {
                ...state,
                loading: false,
                woodenProductsPerGroup: payload
            }
        case GET_WOODEN_PRODUCTS_PER_FACILITY_SUCCESS:
            return {
                ...state,
                loading: false,
                woodenProductsPerFacility: payload
            }
        case GET_WOODEN_PRODUCTS_PER_FACILITY_FAIL:
            return {
                ...state,
                loading: false,
                woodenProductsPerFacility: payload
            }
        case GET_PACKAGING_PER_GROUP_SUCCESS:
            return {
                ...state,
                loading: false,
                packagingPerGroup: payload
            }
        case GET_PACKAGING_PER_GROUP_FAIL:
            return {
                ...state,
                loading: false,
                packagingPerGroup: payload
            }
        case GET_PACKAGING_PER_FACILITY_SUCCESS:
            return {
                ...state,
                loading: false,
                packagingPerFacility: payload
            }
        case GET_PACKAGING_PER_FACILITY_FAIL:
            return {
                ...state,
                loading: false,
                packagingPerFacility: payload
            }
        case GET_WINE_AND_GRAPES_PER_GROUP_SUCCESS:
            return {
                ...state,
                loading: false,
                wineAndGrapesPerGroup: payload,
            }
        case GET_WINE_AND_GRAPES_PER_GROUP_FAIL:
            return {
                ...state,
                loading: false,
                wineAndGrapesPerGroup: payload,
            }
        case GET_WINE_AND_GRAPES_PER_FACILITY_SUCCESS:
            return {
                ...state,
                loading: false,
                wineAndGrapesPerFacility: payload,
            }
        case GET_WINE_AND_GRAPES_PER_FACILITY_FAIL:
            return {
                ...state,
                loading: false,
                wineAndGrapesPerFacility: payload,
            }
        case GET_OTHER_PER_GROUP_SUCCESS:
            return {
                ...state,
                loading: false,
                otherPerGroup: payload
            }
        case GET_OTHER_PER_GROUP_FAIL:
            return {
                ...state,
                loading: false,
                otherPerGroup: payload
            }
        case GET_OTHER_PER_FACILITY_SUCCESS:
            return {
                ...state,
                loading: false,
                otherPerFacility: payload
            }
        case GET_OTHER_PER_FACILITY_FAIL:
            return {
                ...state,
                loading: false,
                otherPerFacility: payload
            }
        case GET_FERTILIZERS_PER_GROUP_SUCCESS:
            return {
                ...state,
                loading: false,
                fertilizersPerGroup: payload
            }
        case GET_FERTILIZERS_PER_GROUP_FAIL:
            return {
                ...state,
                loading: false,
                fertilizersPerGroup: payload
            }
        case GET_FERTILIZERS_PER_FACILITY_SUCCESS:
            return {
                ...state,
                loading: false,
                fertilizersPerFacility: payload
            }
        case GET_FERTILIZERS_PER_FACILITY_FAIL:
            return {
                ...state,
                loading: false,
                fertilizersPerFacility: payload
            }
        case GET_AGROCHEMICALS_PER_GROUP_SUCCESS:
            return {
                ...state,
                loading: false,
                agrochemicalsPerGroup: payload
            }
        case GET_AGROCHEMICALS_PER_GROUP_FAIL:
            return {
                ...state,
                loading: false,
                agrochemicalsPerGroup: payload
            }
        case GET_AGROCHEMICALS_PER_FACILITY_SUCCESS:
            return {
                ...state,
                loading: false,
                agrochemicalsPerFacility: payload
            }
        case GET_AGROCHEMICALS_PER_FACILITY_FAIL:
            return {
                ...state,
                loading: false,
                agrochemicalsPerFacility: payload
            }
        case GET_CAPITAL_GOODS_AND_SERVICES_PER_GROUP_SUCCESS:
            return {
                ...state,
                loading: false,
                capitalGoodsAndServicesPerGroup: payload
            }
        case GET_CAPITAL_GOODS_AND_SERVICES_PER_GROUP_FAIL:
            return {
                ...state,
                loading: false,
                capitalGoodsAndServicesPerGroup: payload
            }
        case GET_CAPITAL_GOODS_AND_SERVICES_PER_FACILITY_SUCCESS:
            return {
                ...state,
                loading: false,
                capitalGoodsAndServicesPerFacility: payload
            }
        case GET_CAPITAL_GOODS_AND_SERVICES_PER_FACILITY_FAIL:
            return {
                ...state,
                loading: false,
                capitalGoodsAndServicesPerFacility: payload
            }
        case EXPORT_COMPANY_CONSUMPTION_SUCCESS:
            return {
                ...state,
                loading: false,
                companyConsumptionExport: payload
            }
        case EXPORT_COMPANY_CONSUMPTION_FAIL:
            return {
                ...state,
                loading: false,
                companyConsumptionExport: payload
            }
        case EXPORT_GROUP_CONSUMPTION_SUCCESS:
            return {
                ...state,
                loading: false,
                groupConsumptionExport: payload
            }
        case EXPORT_GROUP_CONSUMPTION_FAIL:
            return {
                ...state,
                loading: false,
                groupConsumptionExport: payload
            }
        default:
            return state;
    }
}


